export default {
  folder: "x70s",
  initialFrame: 5,
  interior: {
    points: [
      [2500, -300, 0], // 10.5 Inches Touch-screen Infotainment System
      [-2000, -400, 0], // 7 Seater Capacity
      [2500, -500, -1000], // 12.3 Inch Digital Instrument Display
      [2500, -800, -1000], // Multi-function Steering Wheel
    ],
  },
  exterior: {
    hotspots: {
      h1: {
        // Smart LED Lights
        popup: 1,
        point: [
          [37, 59], // f1
          [31, 58], // f2
          [26, 59], // f3
          [22, 58], // f4
          [45, 58], // f5
          [41, 57], // f6
          [36, 57], // f7
          [32, 56], // f8
          [28, 55], // f9
          [26, 54], // f10
          [23, 53], // f11
          [22, 51], // f12
          [21, 49], // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          [80, 49], // f29
          [77, 51], // f30
          [74, 52], // f31
          [70, 54], // f32
          [64, 56], // f33
          [57, 57], // f34
          [48, 57], // f35
          [40, 58], // f36
        ],
      },
      h2: {
        // 20 inch alloy wheels
        popup: 2,
        point: [
          [30, 77], // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          [48, 77], // f6
          [46, 76], // f7
          [42, 77], // f8
          [38, 75], // f9
          [35, 74], // f10
          [33, 72], // f11
          [31, 69], // f12
          [29, 66], // f13
          [28, 65], // f14
          [67, 65], // f15
          [63, 64], // f16
          [58, 64], // f17
          [54, 65], // f18
          [50, 65], // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          [58, 67], // f24
          [52, 67], // f25
          [46, 68], // f26
          [41, 68], // f27
          [75, 62], // f28
          [72, 65], // f29
          [68, 68], // f30
          [67, 71], // f31
          [59, 73], // f32
          [53, 75], // f33
          [47, 76], // f34
          [40, 76], // f35
          [34, 77], // f36
        ],
      },
      h3: {
        // Starry Intake Grill
        popup: 3,
        point: [
          [46, 59], // f1
          [39, 59], // f2
          [33, 59], // f3
          [39, 59], // f4
          [33, 58], // f5
          [28, 58], // f6
          [24, 57], // f7
          [21, 57], // f8
          [19, 55], // f9
          [17, 54], // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          [72, 57], // f33
          [66, 57], // f34
          [59, 58], // f35
          [51, 59], // f36
        ],
      },
      h4: {
        // Panoramic Sunroof
        popup: 4,
        point: [
          [38, 37], // f1
          [38, 37], // f2
          [38, 37], // f3
          [38, 37], // f4
          [40, 37], // f5
          [42, 36], // f6
          [45, 36], // f7
          [47, 35], // f8
          [48, 35], // f9
          [51, 33], // f10
          [55, 30], // f11
          [57, 28], // f12
          [56, 28], // f13
          [57, 26], // f14
          [57, 24], // f15
          [57, 23], // f16
          [57, 21], // f17
          [57, 21], // f18
          [58, 20], // f19
          [58, 20], // f20
          [58, 20], // f21
          [58, 20], // f22
          [58, 20], // f23
          [58, 20], // f24
          [58, 21], // f25
          [55, 22], // f26
          [52, 24], // f27
          [51, 24], // f28
          [48, 25], // f29
          [47, 26], // f30
          [44, 27], // f31
          [42, 29], // f32
          [41, 30], // f33
          [38, 33], // f34
          [36, 34], // f35
          [35, 35], // f36
        ],
      },
      h5: {
        // Easy Open Trunk
        popup: 5,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          [80, 43], // f17
          [75, 44], // f18
          [69, 46], // f19
          [63, 48], // f20
          [56, 49], // f21
          [51, 50], // f22
          [43, 51], // f23
          [36, 50], // f24
          [30, 50], // f25
          [26, 49], // f26
          [22, 48], // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
    },
  },
};
